import colors from '../colors';

const colorsTheme = {
  text: colors.Black,
  background: colors.White,
  pushBackground: colors.Mercury,
  tooltipBackground: colors.White,
  modalBackground: colors.Mystic,
};

export default colorsTheme;
